// Generated by scripts/build-ui-icons.mjs.
export { Signature as default } from "../ui/glyphs-6";
